<template>
  <div class="clientsAdd">
    <div class="pageContent">
      <heading type="h1">Add Client</heading>
      <spinner v-if="loading" />
      <client-form :submit="add" :isAddClient="true" :client="clientNew" @loading="onLoadingStatus" />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import ClientForm from '@/components/ClientForm/client-form'
import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {pageMixin} from '@/mixins/pageMixin'

export default {
  name: 'ClientsAdd',
  mixins: [clientMixin, notificationMixin, pageMixin],
  components: {
    Heading,
    ButtonCta,
    Spinner,
    ClientForm
  },
  data: () => ({
    loading: true,
    clientNew: {
      currency: 'gbp'
    }
  }),
  methods: {
    add () {
      this.loading = true
      this.addClient(this.clientNew).then((response) => {
        this.loading = false
        this.addNotification('success', 'New client added.')
        this.$router.push({path: `/client/${this.client.hash_id}/edit`, query: { notification: true }})
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
    .clientsEdit {
    }
</style>



// WEBPACK FOOTER //
// src/pages/client/clients-add.vue